<template>
  <div class="law_statute">
    <div class="flfg_container">
      <div style="width: 95%; margin: auto">
        <div class="headerSearch">
          <div class="sousuo">
            <el-form
              style="display: flex"
              class="t_search_form"
              label-position="left"
              label-width="90px"
              :model="configForm"
            >
              <el-form-item label="企业类型:" label-width="100px">
                <el-input
                  v-model="configForm.param.title"
                  placeholder="请输入"
                />
              </el-form-item>
              <el-form-item label="发布时间:">
                <el-date-picker
                  v-model="configForm.param.time"
                  type="date"
                  style="width: 100%"
                  placeholder="时间"
                  value-format="yyyy-MM-dd"
                />
              </el-form-item>
              <el-button
                v-preventReClick
                class="sousuoButton"
                icon="el-icon-search"
                round
                size="small"
                type="primary"
                @click="handleCurrentChange(1)"
              >搜索</el-button>
              <el-button
                v-preventReClick
                class="chongzhiButton"
                size="small"
                icon="el-icon-refresh-right"
                round
                @click="reset"
              >重置</el-button>
            </el-form>
          </div>
        </div>
        <div
          style="
            max-width: 1518px;
            background-color: white;
            padding-top: 40px;
            padding-bottom: 57px;
            margin-left: auto;
            margin-right: auto;
          "
        >
          <div class="tablemes">
            <el-table
              v-loading="loading"
              :header-cell-style="{ background: '#F2F2F2' }"
              border
              :data="tableData"
              style="width: 100%"
            >
              <el-table-column
                align="center"
                label="企业"
                :show-overflow-tooltip="true"
              >
                <template>
                  <span>手动输入假数据</span>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="类型"
                :show-overflow-tooltip="true"
              >
                <template>
                  <span>手动输入假数据</span>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="发布时间"
                :show-overflow-tooltip="true"
              >
                <template>
                  <span>2020-20-20 12:12:12</span>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="状态"
                :show-overflow-tooltip="true"
              >
                <!-- 已提交 已处置 未提交？ -->
                <template>
                  已读
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="操作"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="primary"
                    style="background: #4170ff"
                    @click="seeBg(scope.row)"
                  >查看</el-button>
                  <el-button
                    size="mini"
                    type="primary"
                    style="background: #4170ff"
                    @click="addBg(scope.row)"
                  >报告</el-button>
                </template>
              </el-table-column>
            </el-table>

            <el-pagination
              background
              layout="prev, pager,next,jumper,total,sizes"
              :page-sizes="[10, 20, 30]"
              :total="total"
              :page-size="configForm.size"
              class="el-page"
              :current-page.sync="configForm.page"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
            />
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      v-if="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="titleText"
      :visible.sync="dialogVisible"
      destroy-on-close
      center
      width="953px"
    >
      <bg-dialog
        ref="xxhdDocument"
        :current-value="currentValue"
        :form-row="formRow"
        @listenClose="closeDialog"
      />
    </el-dialog>

  </div>
</template>
<script>
import BgDialog from './bgdialog.vue'

export default {
  components: { BgDialog },
  props: {},
  data() {
    return {
      dialogVisible: false,
      currentValue: {
        value: 1
      },
      formRow: {},
      content: '',
      pupopShow: false,
      loading: false,
      pagesize: 4,
      currentPage: 1,
      noticeId: 0, // 查看详情id
      tableData: [{
        value: ''
      }],
      configForm: {
        page: 1,
        size: 10,
        param: {
          title: '',
          time: ''
        }
      },
      total: 0
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.hallTzgg()
  },
  beforeDestroy() {},
  methods: {
    // 监听弹框的关闭按钮
    closeDialog() {
      this.dialogVisible = false
    },
    // 查看
    seeBg(row) {
      this.titleText = '查看报告'
      this.currentValue = {
        title: '查看报告',
        value: 2
      }
      this.formRow = row
      this.dialogVisible = true
    },
    // 新增
    addBg() {
      this.titleText = '报告投诉'
      this.dialogVisible = true
      this.currentValue = {
        title: '报告投诉',
        value: 1
      }
    },
    reset() {
      this.configForm = {
        page: 1,
        size: 10,
        param: {
          title: '',
          time: ''
        }
      }
      this.hallTzgg()
    },
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      this.configForm.page = val
      this.hallTzgg()
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.pagesize = val
      this.configForm.size = val
      this.hallTzgg()
    },

    // 获取数据
    hallTzgg() {

    }
  }
}
</script>
<style scoped lang="less">
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
/deep/.el-date-editor .el-range-separator {
  padding: 0 5px;
  line-height: 32px;
  width: 30px !important;
  color: #303133;
}
.flfg_container {
  // height: 100%;
  .headerSearch {
    max-width: 1518px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 11px;
    margin-top: 30px;
    background-color: white;
    padding: 30px 0 20px 0;
    // border: 1px solid red;
    display: flex;
    align-items: center;
    box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    .el-form-item {
      margin-bottom: 10px;
      margin-right: 30px;
      &:last-child {
        // width: 90px;
        // height: 39px;
        /deep/ .el-button {
          width: 90px !important;
          height: 39px;
          border-radius: 3px;
        }
      }
    }
  }
  .sousuo {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    .sousuoButton {
      width: 90px;
      height: 39px;
      background: #4170ff;
      border-color: #4170ff;
    }
    .chongzhiButton {
      width: 90px;
      height: 39px;
    }
  }
  .tablemes {
    width: 90%;
    margin: auto;
    max-width: 1375px;
    // margin-top: 21px;
    // margin-bottom: 57px;
    .el-pagination__total {
      margin-left: 8px;
    }
    .el-pagination {
      padding: 10px 0;

      border: 1px solid #ebeef5;
      border-top: 0;
    }
    .deleteButton {
      background: #ff5721 !important;
      border-color: #ff5721 !important;
    }
    .el-button--warning {
      color: #fff;
      background: #feb800;
      border-radius: 3px;
      border-color: #feb800;
    }
    .el-button--primary {
      color: #fff;
      background: #4170ff;
      border-radius: 3px;
      border-color: #4170ff;
    }
    .el-pager {
      .number {
        background: #4170ff;
        border-color: #4170ff;
      }
    }
  }
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}
/deep/ .disableheadselection > .cell .el-checkbox__inner {
  display: none !important;
}
</style>
